import { PurchaseRequestOfferStatus } from "@slfinrtl/ui-bff-routes"

/**
 * Offer state of a purchase request from the viewing dealer's perspective, tracked as eVar198.
 * - `with_offer`: the viewing dealer has already submitted an offer
 * - `without_offer`: the viewing dealer has not made an offer, but other dealers have
 * - `no_offer`: the purchase request has never received an offer from any dealer
 */
export type PurchaseRequestOfferState = "with_offer" | "without_offer" | "no_offer"

interface GetPurchaseRequestOfferStateProps {
	offerStatus: PurchaseRequestOfferStatus
	totalNumberOfOffers: number
}

export const getPurchaseRequestOfferState = ({
	offerStatus,
	totalNumberOfOffers,
}: GetPurchaseRequestOfferStateProps): PurchaseRequestOfferState => {
	if (offerStatus !== PurchaseRequestOfferStatus.NO_OFFER) {
		return "with_offer"
	}

	return totalNumberOfOffers > 0 ? "without_offer" : "no_offer"
}
